import { useState, useRef } from 'react';
import InfoPageFrame from './InfoPageFrame';
import HTMLPage from './HTMLPage';
import ImageCarousel from './ImageCarousel';

export default function InfrastructureInfo(props) {

    const [ infrastructureData, setInfrastructureData] = useState(null);
    const carousel = useRef(null);

    const contacts = infrastructureData?.contact;   

    return <InfoPageFrame 
        file={`./infrastructure/${props.file}`}
        name={infrastructureData?.name}
        logo={infrastructureData?.logo}
        keywords={infrastructureData?.keywords}
        leaders={contacts}
        presence={infrastructureData?.presence}
        lang={props.lang}
        onPageDataLoaded={dta => { setInfrastructureData(dta); if (carousel.current) carousel.current.moveTo(0); }}
        >
            {infrastructureData && <>     
                {<ImageCarousel carouselRef={carousel} imageList={infrastructureData.images} /> }
                <HTMLPage prefix="./infrastructure/" file={infrastructureData.page} lang={props.lang} />
            </>}
        </InfoPageFrame>;
}
